import { v4 as uuidv4 } from 'uuid';

export class CommonList {
  public readonly id: string;
  public readonly label: string;
  public icon: string;
  public data: ObjectType<any>;
  public desc: string;
  public disabled = false;

  constructor(label: string, id?: string) {
    this.id = id || uuidv4();
    this.label = label;
  }

  public setData(data: ObjectType<any>): CommonList {
    this.data = data;
    return this;
  }

  public setIcon(icon: string): CommonList {
    this.icon = icon;
    return this;
  }

  public setDesc(desc: string): this {
    this.desc = desc;
    return this;
  }

  public setDisabled(disabled: boolean): this {
    this.disabled = disabled;
    return this;
  }

  static create(label: string, id?: string): CommonList {
    return new CommonList(label, id);
  }
}
